import {
  RiPhoneLine,
  RiVidiconLine,
  RiChat1Line,
  RiUserReceived2Line,
  RiHospitalLine,
  RiHome4Line,
  RiCommunityLine,
  RiAlarmWarningLine,
} from "react-icons/ri";

const iconMap = {
  Audio: RiPhoneLine,
  Video: RiVidiconLine,
  Chat: RiChat1Line,
  "Follow-Up": RiUserReceived2Line,
  Clinic: RiHospitalLine,
  "Home Visit": RiHome4Line,
  rpm: RiCommunityLine,
  Emergency: RiAlarmWarningLine,
};

const labelMap = {
  Audio: "Audio Appointment",
  Video: "Video Appointment",
  Chat: "Chat Appointment",
  "Follow-Up": "Follow-up Appointment",
  Clinic: "Clinic Appointment",
  "Home Visit": "Home Appointment",
  rpm: "RPM Appointment",
  Emergency: "Emergency Appointment",
};

export default function AppointmentIcon({
  type,
  label,
  className = "",
  iconSize = 24,
}) {
  const Icon = iconMap[type];
  const finalLabel = label || labelMap[type];

  if (!Icon) return null;

  return (
    <div className="relative group w-fit">
      <Icon size={iconSize} className={className + " cursor-pointer"} />

      {/* Tooltip */}
      <div className="absolute -top-9 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition-transform duration-200 bg-black text-white text-xs rounded px-2 py-1 whitespace-nowrap z-20">
        {finalLabel}
      </div>
    </div>
  );
}
